export default "__VITE_ASSET__813cb616__"